const ERROR_BLACKLIST = ["ERR_CONNECTION_CLOSED", "lovable.dev/ingest"];

export const isRelevantError = (error: any): boolean => {
  if (typeof error === "string") {
    return !ERROR_BLACKLIST.some((blacklisted) => error.includes(blacklisted));
  }
  if (error instanceof Error) {
    return !ERROR_BLACKLIST.some((blacklisted) => error.message.includes(blacklisted));
  }
  return true;
};

const originalConsoleError = console.error;
console.error = (...args) => {
  if (args.some((arg) => !isRelevantError(arg))) {
    return;
  }
  originalConsoleError.apply(console, args);
};

export const log = {
  fields: (message: string, ...args: any[]) => {
    console.log(`[Fields] ${message}`, ...args);
  },
  template: (message: string, ...args: any[]) => {
    console.log(`[Template] ${message}`, ...args);
  },
  process: (message: string, data?: any) => {
    if (data !== undefined) {
      try {
        // Try to format the data for better readability
        const formattedData = typeof data === "object" ? data : { value: data };
        console.log(`[Process] ${message}`, formattedData);
      } catch (_e) {
        console.log(`[Process] ${message}`, data);
      }
    } else {
      console.log(`[Process] ${message}`);
    }
  },
  warn: (message: string, ...args: any[]) => {
    console.warn(`[Warning] ${message}`, ...args);
  },
  error: (message: string, error: unknown) => {
    if (isRelevantError(error)) {
      console.error(`[Error] ${message}:`, error);
    }
  },
};
